import type { FunctionComponent, ReactNode } from "react"

import { clsx } from "clsx"

import styles from "./FixedAspectRatioContainer.module.css"

export const ASPECT_RATIOS = {
  W16_H9: "W16H9",
}

type FixedAspectRatioContainerProps = {
  aspectRatio?: {
    [key: string]: string
  }
  children: ReactNode
  className?: string
}
/**
 * Renders a visual container with an specific fix aspect ratio.
 * By default it will be 16:9.
 */
export const FixedAspectRatioContainer: FunctionComponent<FixedAspectRatioContainerProps> = ({
  aspectRatio = ASPECT_RATIOS.W16_H9,
  children,
  className,
}) => (
  <div className={className}>
    <div className={clsx(styles.fixedAspectRatioContainer, styles[`fixedAspectRatioContainer--${aspectRatio}`])}>
      <div className={styles.fixedAspectRatioContainer__inner}>{children}</div>
    </div>
  </div>
)
